export default __webpack_public_path__ + "a0bccc2e609a957f6b5237146de0e6a8.svg";